import React from "react";

interface PoweredByPerplexityProps {
  className?: string;
}

export const PoweredByPerplexity: React.FC<PoweredByPerplexityProps> = ({
  className = "",
}) => {
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <img
        src="/images/perplexityLogo.png"
        alt="Perplexity"
        className="h-5 opacity-80"
      />
    </div>
  );
};
